<template>
  <v-card
    elevation="0"
    outlined
  >
    <v-card-title>
      <v-icon class="mr-2">
        mdi-table
      </v-icon>
      Report Data
    </v-card-title>
    <v-card-text>
      <div class="table-wrapper">
        <v-data-table
          :headers="reportHeaders"
          :items="flattenedReportData"
          :items-per-page="10"
          multi-sort
          fixed-header
        >
          <template #item.matchedLeadPercentage="{ item }">
            {{ item.matchedLeadPercentage }}%
          </template>
          <template #item.acceptedLeadPercentage="{ item }">
            {{ item.acceptedLeadPercentage }}%
          </template>
          <template #item.acceptanceRate="{ item }">
            {{ item.acceptanceRate }}%
          </template>
          <template #item.fundingRate="{ item }">
            {{ item.fundingRate }}
          </template>
          <template #item.fundedLeadPercentage="{ item }">
            {{ item.fundedLeadPercentage }}%
          </template>
          <template #item.totalFundedAmount="{ item }">
            ${{ item.totalFundedAmount.toLocaleString() }}
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatPercentage } from '@/filters.js';

export default {
  name: 'ReportTable',

  props: {
    reportData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      reportHeaders: [
        {
          title: 'Bucket Type',
          value: 'bucketType',
          sortable: true,
        },
        {
          title: 'Test Name',
          value: 'testName',
          sortable: true,
        },
        {
          title: 'Strategy Name',
          value: 'strategyName',
          sortable: true,
        },
        {
          title: 'Matched Leads',
          value: 'matchedLeadCount',
          sortable: true,
        },
        {
          title: 'Accepted Leads',
          value: 'acceptedLeadCount',
          sortable: true,
        },
        {
          title: 'Acceptance %',
          value: 'acceptanceRate',
          sortable: true,
        },
        {
          title: 'Funded Leads',
          value: 'fundedLeadCount',
          sortable: true,
        },
        {
          title: 'Funding %',
          value: 'fundingRate',
          sortable: true,
        },
        {
          title: 'Total Funded Amount',
          value: 'totalFundedAmount',
          sortable: true,
        },
      ],
    };
  },

  computed: {
    flattenedReportData() {
      const flattened = [];

      this.reportData.forEach((bucket) => {
        bucket.tests.forEach((test) => {
          test.strategies.forEach((strategy) => {
            flattened.push({
              bucketType: bucket.bucketType,
              testName: test.testName,
              strategyName: strategy.strategyName,
              ...strategy.summary,
            });
          });
        });
      });

      return flattened;
    },
  },

  methods: {
    formatPercentage,
  },
};
</script>

<style scoped>
.table-wrapper {
  overflow-x: auto;
  width: 100%;
}

.table-wrapper :deep(.v-data-table-header th) {
  white-space: nowrap;
}
</style>
